import { Component, EventEmitter, OnInit, ViewEncapsulation, Input, Output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { DatacenterCodeTranslationFilterType,
	DynamicDatacenterFilter, SuggestiveListFilter } from '../../../models/datacenter-filters';
import { pageTransitions } from '../../../animations/page-transitions';
import { AdditionalInput } from '../../../models/datacenter-aggrid-view';
import { ProductListFilterApiService } from '../services/product-list-filter-api.service';

import { ProductSuggestiveItemFilterComponent } from './suggestive-item-filter.component';

@Component({
	selector: 'copo-product-suggestive-list-filter',
	templateUrl: './suggestive-list-filter.component.html',
	styleUrl: './suggestive-list-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	providers: [ProductListFilterApiService],
	imports: [NgIf, NgFor, MatIconModule, MatRippleModule, ProductSuggestiveItemFilterComponent]
})
export class SuggestiveListFilterComponent implements
		OnInit, DynamicDatacenterFilter<SuggestiveListFilter> {
	@Input() filter?: SuggestiveListFilter;
	@Input() additionalInput?: AdditionalInput;
	@Output() readonly removeFilter = new EventEmitter<void>();

	constructor(private readonly filterApiService: ProductListFilterApiService) {}

	ngOnInit() {
		this.filterApiService.datacenterFilter = this.filter;
	}

	removeValue(item: DatacenterCodeTranslationFilterType) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(this.filter.getValues().findIndex(search => search.code === item.code), 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(_index: number, item: DatacenterCodeTranslationFilterType) {
		return item.code;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return {
				id: this.filter.filterId,
				values: this.filter.getValues()
					.filter(filterValue => !filterValue.translation)
			};
		}
		return undefined;
	}
}
